export class DetalleDteRentencion {
   detalleDteId: string;
   codigoSii: number;
   nombreRetencion: string;
   valor: number;
}
